import { ArcLayer } from '@deck.gl/layers';
const defaultProps = {
    getHeight: { type: 'accessor', value: 0 },
    greatCircle: true
};
// This layer has been merged into the core ArcLayer
// Keeping for backward-compatibility
/** @deprecated Use ArcLayer with `greatCircle: true` instead */
class GreatCircleLayer extends ArcLayer {
}
GreatCircleLayer.layerName = 'GreatCircleLayer';
GreatCircleLayer.defaultProps = defaultProps;
export default GreatCircleLayer;
